module.exports = __webpack_public_path__ + "static/media/bankicon.44c96777.svg";